import { GearSix } from "@phosphor-icons/react";
import { useEffect } from "react";

import { Button } from "common/components/ui/Button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuList,
  DropdownMenuTrigger,
} from "common/components/ui/DropdownMenu";
import RadioButton from "common/components/ui/RadioButton";

// Options for the settings popover
const options = [
  {
    id: "enter-send",
    isEnabled: false,
    label: "Enter to Send",
    description: "Ctrl + Enter to add a new line",
  },
  {
    id: "enter-new-line",
    isEnabled: true,
    label: "Enter to add a new line",
    description: "Ctrl + Enter will send a message",
  },
];

interface SettingsPopupProps {
  ctrlToSend: boolean;
  setCtrlToSend: (ctrlToSend: boolean) => void;
  isDisabled: boolean;
}

export default function SettingsPopup({
  ctrlToSend,
  setCtrlToSend,
  isDisabled,
}: SettingsPopupProps) {
  useEffect(() => {
    localStorage.setItem("ctrlToSend", ctrlToSend.toString());
  }, [ctrlToSend]);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild disabled={isDisabled}>
        <Button
          intent="iconOnly"
          variant="ghost-black"
          size="xs"
          className="data-[state=open]:bg-black-100"
        >
          <GearSix />
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent>
        <DropdownMenuList>
          {options.map(({ id, isEnabled, label, description }) => (
            <DropdownMenuItem key={id} onClick={() => setCtrlToSend(isEnabled)}>
              <RadioButton
                className="mb-auto"
                isStyleOnly
                variant="black"
                checked={ctrlToSend === isEnabled}
              />

              <div className="flex flex-col items-start gap-0.5">
                <span className="text-button-sm">{label}</span>
                <span className="text-xs text-black-400">{description}</span>
              </div>
            </DropdownMenuItem>
          ))}
        </DropdownMenuList>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
